import { Dispensary } from "custom-types/Dispensary";

import Tag from "components/botanic/Tag";

const DispensaryFeatures: React.FC<{ dispensary: Dispensary }> = ({
  dispensary,
}) => {
  const {
    hasAtm,
    acceptsCash,
    acceptsCreditCards,
    acceptsDebitCards,
    isUfcwMember,
    isAdaAccessible,
    hasVeteranDiscount,
    clinicWalkInsWelcome,
    verifiesMedicalCards247,
    offersWalletSizedMedicalCards,
    offersMedicalCards,
    tags = [],
  } = dispensary;

  // It's unclear which of these canadaLp tag casings is correct, so checking for both
  const isLicensedProducer =
    tags.includes("canadaLp") || tags.includes("canadaLP");
  const isMedical = tags.includes("medical");
  const isRec = tags.includes("recreational");
  const isDelivery = tags.includes("delivery");
  const isAzLicensed = tags.includes("azlicensed");
  const isComingSoon = tags.includes("comingsoon");
  const isMedDelivery = tags.includes("delivery") && tags.includes("medical");
  const isStorefront = tags.includes("storefront");

  const featuresCollection: [boolean, string][] = [
    [hasAtm, "hasAtm"],
    [acceptsCash, "acceptsCash"],
    [acceptsCreditCards, "acceptsCreditCards"],
    [acceptsDebitCards, "acceptsDebitCards"],
    [isStorefront, "isStorefront"],
    [isUfcwMember, "isUfcwMember"],
    [isAdaAccessible, "isAdaAccessible"],
    [hasVeteranDiscount, "hasVeteranDiscount"],
    [clinicWalkInsWelcome, "clinicWalkInsWelcome"],
    [verifiesMedicalCards247, "verifiesMedicalCards247"],
    [offersWalletSizedMedicalCards, "offersWalletSizedMedicalCards"],
    [offersMedicalCards, "offersMedicalCards"],
  ];

  const tagsCollection: [boolean, string][] = [
    [isLicensedProducer, "isLicensedProducer"],
    [isMedical, "isMedical"],
    [isRec, "isRec"],
    [isDelivery, "isDelivery"],
    [isMedDelivery, "isMedDelivery"],
    [isAzLicensed, "isAzLicensed"],
    [isComingSoon, "isComingSoon"],
  ];

  const featuresMap: { [key: string]: string } = {
    acceptsCash: "cash accepted",
    acceptsCreditCards: "credit cards accepted",
    acceptsDebitCards: "debit cards accepted",
    clinicWalkInsWelcome: "walk-ins welcome",
    hasAtm: "ATM",
    hasVeteranDiscount: "veteran discount",
    isAdaAccessible: "ADA accesible",
    isStorefront: "storefront",
    isUfcwMember: "UFCW discount",
    offersMedicalCards: "offers physical cards",
    offersWalletSizedMedicalCards: "wallet-sized authorizations",
    verifiesMedicalCards247: "24/7 verification",
  };

  const tagsMap: { [key: string]: string } = {
    isAzLicensed: "AZ licenced",
    isComingSoon: "coming soon",
    isDelivery: "delivery",
    isLicensedProducer: "Canada lp",
    isMedDelivery: "medical delivery",
    isMedical: "medical",
    isRec: "recreational",
  };

  function getDispensaryFeatures() {
    return featuresCollection.map((feature) => {
      return (
        feature[0] &&
        featuresMap[feature[1]] && (
          <Tag className="mr-xs mb-xs" key={feature[1]}>
            {featuresMap[feature[1]]}
          </Tag>
        )
      );
    });
  }

  function getDispensaryTags() {
    return tagsCollection.map((tag) => {
      return (
        tag[0] && (
          <Tag className="mr-xs mb-xs" key={tag[1]}>
            {tagsMap[tag[1]]}
          </Tag>
        )
      );
    });
  }
  return (
    <div>
      {getDispensaryFeatures()}
      {getDispensaryTags()}
    </div>
  );
};

export default DispensaryFeatures;
